import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import ResetPassword from "pages/Auths/reset-password";
import ChangePassword from "pages/Auths/change-password";
import Thankyou from "pages/Auths/thank-you";
import BusinessSetup from "pages/Auths/business-setup";
import EmailOtp from "pages/Auths/email-otp";
import SignUpVerifyOtp from "pages/Auths/signup-verify-otp";
import LiveOrders from "pages/live-orders";
import MenuMangment from "pages/menu-management";
import CustomerReviews from "pages/customer-reviews";
import Login from "pages/login";
import StoresOverview from "pages/store-overview";
import ManageStores from "pages/manage-stores";
import Settings from "pages/settings";
import Reports from "pages/reports";
import OrderHistory from "pages/order-history";
import Dashboard from "pages/dashboard";
import Signup from "pages/Auths/signup";
import Pages from "pages/index";
import {useContextHook} from "use-context-hook";
import {AuthContext, useAuthContext} from "Context/authContext";
import PricingList from "components/atoms/PricingList";
import Payment from "pages/Auths/payment";
import WebsiteBuilder from "pages/website-builder";
import Layout from "components/Layout";
import Template from "pages/template";
import BillingSuccess from "pages/billing-success";
import SubscriptionGuard from "components/SubscriptionGuard";

const Router = () => {
    const {isLoggedIn, allowedPages} = useAuthContext();
    // let isLoggedIn = false;
    function PublicRoute({children, redirectTo, isLoggedIn}) {
        return isLoggedIn ? <Navigate to={redirectTo} /> : children;
    }

    function PrivateRoute({children, redirectTo, isLoggedIn}) {
        return isLoggedIn ? children : <Navigate to={redirectTo} />;
    }

    const redirectTo = allowedPages?.length > 0 ? `/${allowedPages[0]}` : "/dashboard";

    return (
        <>
            <Routes>
                <Route
                    path="/:view"
                    element={
                        <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
                            <SubscriptionGuard>
                                <Pages />
                            </SubscriptionGuard>
                        </PrivateRoute>
                    }
                />
                {/* <Route
                    path="*"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
                            <Login />
                        </PublicRoute>
                    }
                /> */}
                <Route path="*" element={<Login />} />
                <Route
                    path="/reset-password"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
                            <ResetPassword />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/change-password"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
                            <ChangePassword />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/thank-you"
                    element={
                        <PublicRoute redirectTo={redirectTo}>
                            <Thankyou />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/pricing"
                    element={
                        <PrivateRoute isLoggedIn={isLoggedIn} redirectTo="/">
                            <SubscriptionGuard>
                                <PricingList />
                            </SubscriptionGuard>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/billing/success"
                    element={
                        <PrivateRoute isLoggedIn={isLoggedIn} redirectTo={"/"}>
                            <BillingSuccess />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/payment"
                    element={
                        <PublicRoute redirectTo={redirectTo}>
                            <Payment />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/business-setup"
                    element={
                        <PrivateRoute isLoggedIn={isLoggedIn} redirectTo={"/"}>
                            <BusinessSetup />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/website-builder"
                    element={
                        <PrivateRoute isLoggedIn={isLoggedIn} redirectTo={"/"}>
                            <SubscriptionGuard>
                                <Layout>
                                    <WebsiteBuilder />
                                </Layout>
                            </SubscriptionGuard>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/website-builder/template"
                    element={
                        <PrivateRoute isLoggedIn={isLoggedIn} redirectTo={"/"}>
                            <SubscriptionGuard>
                                <Template />
                            </SubscriptionGuard>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/email-otp"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
                            <EmailOtp />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/signup"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
                            <Signup />
                        </PublicRoute>
                    }
                />

                <Route
                    path="/signup-verify-otp"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
                            <SignUpVerifyOtp />
                        </PublicRoute>
                    }
                />

                {/*         
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/store/overview" element={<StoresOverview />} />
        <Route path="/store/manage-stores" element={<ManageStores />} />
        <Route path="/order/live-orders" element={<LiveOrders />} />
        <Route
          path="/customer/manage-customers"
          element={<ManageCustomers />}
        />
        <Route path="/customer/manage-user" element={<ManageUsers />} />
        <Route path="/customer/manage-roles" element={<ManageRoles />} />
        <Route path="/customer/customer-reviews" element={<CustomerReviews />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="order/orders-history" element={<OrderHistory />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/menu-management" element={<MenuMangment />} /> */}
                {/* <Route
          path="*"
          element={
            <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
              <Login />
            </PublicRoute>
          }
        /> */}
            </Routes>
        </>
    );
};

export default Router;
